import { FC, useState } from "react";
import { observer } from "mobx-react-lite";
import { IButton, IconButton } from "../../ui-kit";
import { authStore } from "../../store/authStore";
import { ChangePasswordForm } from "../../components/AuthPage/ChangePasswordForm/ChangePasswordForm";

import styles from "../styles/ProfileSettings.module.scss";

const ProfileSettings: FC = observer((props) => {
  const [changePwdVisible, setChangePwdVisible] = useState(false);
  const { userProfile } = authStore;
  const getRole = (str: string[]) =>
    Array.isArray(str) && str.length ? str.join(", ") : "";

  return (
    <div className={styles.Layout}>
      <IconButton
        hidden
        className={styles.ProfileEditButton}
        typeIcon="edit"
        variant="text"
        onClick={() => ({})}
      />
      <div className={styles.ProfileValue}>
        <div className={styles.ProfileValueLabel}>ФИО:</div>
        {userProfile?.fullName}
      </div>
      <div className={styles.ProfileValue}>
        <div className={styles.ProfileValueLabel}>Организация:</div>
        {userProfile?.organizationName}
      </div>
      <div className={styles.ProfileValue}>
        <div className={styles.ProfileValueLabel}>Должность:</div>
        {userProfile?.position}
      </div>
      <div className={styles.ProfileValue}>
        <div className={styles.ProfileValueLabel}>Роль:</div>
        {getRole(userProfile?.userGroups)}
      </div>
      <div className={styles.ProfileValue}>
        <div className={styles.ProfileValueLabel}>Телефон:</div>
        {userProfile?.phoneNumber}
      </div>
      <div className={styles.ProfileValue}>
        <div className={styles.ProfileValueLabel}>Email:</div>
        {userProfile?.email}
      </div>
      <IButton
        onClick={() => {
          setChangePwdVisible(true);
        }}
        className={styles.PasswordButton}
      >
        Сменить пароль
      </IButton>
      {changePwdVisible && (
        <ChangePasswordForm
          onCancel={() => {
            setChangePwdVisible(false);
          }}
        />
      )}
    </div>
  );
});

export default ProfileSettings;
